<template>
  <div class="setting-drawer" ref="settingDrawer">
    <a-drawer
      width="300"
      placement="right"
      :closable="false"
      @close="onClose"
      :visible="TaskDrawerOpen"
      :getContainer="() => $refs.settingDrawer"
      :style="{}"
    >
      <div class="setting-drawer-index-content">
        <task-list></task-list>
      </div>
      <div class="setting-drawer-index-handle" @click="toggle">
        <div class="text">任务监控</div>
        <!-- <a-icon type="setting" v-if="!visible"/>
        <a-icon type="close" v-else/>-->
      </div>
      <a-card
        hoverable
        @click="onclear"
        :bordered="false"
        class="setting-drawer-index-fiexbtn"
        :bodyStyle="{padding:0}"
      >
        <a>
          <a-icon type="delete" />清空
        </a>
      </a-card>
    </a-drawer>
  </div>
</template>

<script>
import { mixin, mixinDevice } from '@/utils/mixin'
import TaskList from './TaskList'
import { mapActions, mapMutations } from 'vuex'
export default {
  components: {
    TaskList
  },
  mixins: [mixin, mixinDevice],
  data() {
    return {}
  },
  mounted() {
    setTimeout(() => {
      this.TaskDrawerSwitch({ status: false })
    }, 16)
  },
  computed: {
    TaskDrawerOpen() {
      return this.$store.state.batchpush.TaskDrawerOpen
    }
  },
  methods: {
    ...mapActions(['TaskDrawerSwitch']),
    ...mapMutations(['CLEAR_PUSH_STATUS']),
    onClose() {
      this.TaskDrawerSwitch({ status: false })
    },
    toggle() {
      const status = !this.TaskDrawerOpen
      this.TaskDrawerSwitch({ status })
    },
    onclear() {
      this.CLEAR_PUSH_STATUS()
    }
  }
}
</script>

<style lang="less" scoped>
.setting-drawer-index-content {
}

.setting-drawer-index-handle {
  position: fixed;
  top: 300px;
  background: #1890ff;
  width: 48px;
  height: 48px;
  right: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: auto;
  z-index: 1001;
  text-align: center;
  font-size: 16px;
  border-radius: 4px 0 0 4px;

  i {
    color: rgb(255, 255, 255);
    font-size: 20px;
  }

  .text {
    color: #fff;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    width: 28px;
  }
}
.setting-drawer-index-fiexbtn {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: #fff;
  text-align: center;
  a {
    color: #f5222d;
    font-size: 14px;
    line-height: 50px;
  }
}
</style>
